// front/src/api/docs.api.js
import http from '../http';

export async function createAdminOrder(payload) {
  const { data } = await http.post('/api/admin/orders', payload);
  return data;
}

export async function createInvoiceFromOrder(orderId, { sellerProfileId, force } = {}) {
  const { data } = await http.post('/api/admin/invoices', {
    orderId,
    sellerProfileId,
    force: force ? 1 : undefined,
  });
  return data;
}

export async function createSalesActFromOrder(orderId, { sellerProfileId, force } = {}) {
  const { data } = await http.post('/api/admin/sales-acts', {
    orderId,
    sellerProfileId,
    force: force ? 1 : undefined,
  });
  return data;
}

export async function createOrderPdfFromOrder(orderId, { sellerProfileId, force } = {}) {
  const { data } = await http.get(`/api/admin/orders/${orderId}/pdf`, {
    params: {
      sellerProfileId: sellerProfileId || undefined,
      force: force ? 1 : undefined,
    },
  });
  return data;
}

export async function listOrderDocs(orderId) {
  const { data } = await http.get(`/api/admin/orders/${orderId}/docs`);
  return data.items || [];
}

export async function getDocsArchive(params = {}) {
  const { data } = await http.get('/api/admin/docs', { params });
  return data;
}

export async function deleteDoc(id) {
  const { data } = await http.delete(`/api/admin/docs/${id}`);
  return data;
}

export function toAbsoluteUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = process.env.REACT_APP_API_URL || '';
  return `${base}${url}`;
}
